<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>فترات التغيير</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع فترات التغيير
                                <div v-show="$per.value.saveMaintenanceItem" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                              <div class='form-group col-lg-4 col-sm-4'>
                                <h4 >الفرع:</h4>
                                <select @change='changeBranche()' style="padding:0px" class="form-control" v-model="branch_id">
                                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-4 col-sm-4'>
                                <h4 >المنتج:</h4>
                                <select @change='GetMaintenanceGroups()' style="padding:0px" class="form-control" v-model="product_id">
                                  <option v-for="item in Products" :key="item.id" v-bind:value="item.id">
                                    {{ item.item }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-4 col-sm-4'>
                                <h4 >المجموعة:</h4>
                                <select  @change='GetData()' style="padding:0px" class="form-control" v-model="maintenanceGroup_id">
                                  <option v-for="item in maintenanceGroups" :key="item.id" v-bind:value="item.id">
                                    {{ item.group_name }}
                                  </option>
                                </select>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>
                                          <th style='text-align: center'>الصنف</th>
                                          <th style='text-align: center'>مدة التغيير بالشهر</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in filteredProducts' :key='record.id'>
                                          <td align='center'>{{record.item}}</td>
                                          <td align='center'>{{record.change}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteMaintenanceItem" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editMaintenanceItem" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                             <div class='form-group col-lg-6 col-sm-6'>
                               <span>الفرع:</span>
                               <select @change='changeBranche()' class="form-control" style="padding: 0px" v-model="branch_id">
                                 <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                   {{ item.name }}
                                 </option>
                               </select>
                             </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <span>المنتج:</span>
                                     <select @change='GetMaintenanceGroups()' class="form-control" style="padding: 0px" v-model="product_id">
                                       <option v-for="product in Products" v-bind:key="product.id" v-bind:value="product.id">
                                         {{ product.item }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-4 col-sm-4'>
                                   <span>المجموعة:</span>
                                   <select @change='GetData()' class="form-control" style="padding:0px" v-model="maintenanceGroup_id">
                                     <option v-for="item in maintenanceGroups" :key="item.id" v-bind:value="item.id">
                                       {{ item.group_name }}
                                     </option>
                                   </select>
                                 </div>
                                 <div class='form-group col-lg-4 col-sm-4'>
                                     <span>الصنف:</span>
                                     <select class="form-control" style="padding: 0px" v-model="record.item_id">
                                       <option v-for="item in ChangedItems" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.item }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-4 col-sm-4'>
                                     <span>مدة التغيير بالشهر:</span>
                                     <input v-model='record.change' class='form-control' name='change' type='text'>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'
export default {
  name: 'maintenanceItem',
  data () {
    return {
      validationErrors: '',
      records: {},
      record: {},
      items: {},
      product_id: '',
      maintenanceGroups: {},
      maintenanceGroup_id: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      branches: [],
      branch_id: '',
      title: ''
    }
  },
  created () {
    this.branch_id = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.items = JSON.parse(localStorage.getItem('Items'))
  },
  computed: {
    Products () {
      if (Object.keys(this.items).length !== 0) {
        return this.items.filter(item => item.is_contract === 1)
      }
    },
    ChangedItems () {
      if (Object.keys(this.items).length !== 0) {
        return this.items.filter(item => item.is_contract === 0)
      }
    },
    filteredProducts () {
      if (Object.keys(this.records).length !== 0) {
        return this.records.filter((item) => item.branch_id === Number(this.branch_id))
      }
    }
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getMaintenanceItem', {
        token: localStorage.getItem('token'),
        branche_id: this.branch_id,
        product_id: this.product_id,
        maintenanceGroup_id: this.maintenanceGroup_id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    changeBranche () {
      this.records = ''
      this.product_id = ''
      this.maintenanceGroups = ''
      this.maintenanceGroup_id = ''
    },
    GetMaintenanceGroups () {
      this.records = ''
      this.maintenanceGroups = ''
      this.maintenanceGroup_id = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'GetMaintenanceGroups', {
        token: localStorage.getItem('token'),
        branche_id: this.branch_id,
        product_id: this.product_id
      })
        .then(({ data }) => {
          this.maintenanceGroups = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'item_id': 0, 'change': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveMaintenanceItem', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        branch_id: this.branch_id,
        product_id: this.product_id,
        item_id: this.record.item_id,
        change: this.record.change,
        maintenance_group_id: this.maintenanceGroup_id
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data[0])
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data[0])
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteMaintenanceItem', {
            token: localStorage.getItem('token'),
            id: recID
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              let i = this.records.map(record => record.id).indexOf(recID)
              this.records.splice(i, 1)
              this.isLoadingDelete = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/MaintenanceItems.vue